import React, { BaseSyntheticEvent } from 'react';
import styled from 'styled-components';
//
import InputGroup from 'components/input/group';
import InputTextarea from 'components/input/textarea';
import InputLabel from 'components/input/label';
import InputText from 'components/input/text';
import { UnitButtonContainer, UnitButton } from 'components/unit-toggle/unit-toggle';
import { ICreditProps } from 'components/sidebar/deal-management/credit';
import { EDealField, EPayCycle, EPaymentTerm } from 'store/deals/types';
import {
  creditStandardEndOfMonthTestId,
  creditStandardInvoiceTestId,
  creditProposedEndOfMonthTestId,
  creditProposedInvoiceTestId,
} from 'components/sidebar/base-navigation/test-ids';

const Container = styled.div``;

const InvisibleSpan = styled.span`
  color: transparent;
`;

const DaysInputContainer = styled.div`
  margin-top: 10px;

  span:first-of-type {
    margin: 0px 8px;
    font-size: 16px;
    font-weight: 600;
  }

  ${InputText} {
    width: 50px;
  }

  span:last-of-type {
    margin-left: 8px;
    font-weight: 500;
  }
`;

export default ({
  standardPaymentTermEndOfMonth,
  standardPaymentTermInvoiceDate,
  proposedPaymentTermEndOfMonth,
  proposedPaymentTermInvoiceDate,
  payDelay,
  stdPayDelay,
  probDefault,
  otherCredit,
  updateDealField,
  handleCreditPaymentTermCycleClick,
}: ICreditProps) => {
  return (
    <Container>
      <InputGroup>
        <InputLabel htmlFor="standard-payment-term">STANDARD PAYMENT TERM</InputLabel>
        <UnitButtonContainer>
          <UnitButton
            data-testid={creditStandardEndOfMonthTestId}
            data-isactive={standardPaymentTermEndOfMonth}
            active={standardPaymentTermEndOfMonth}
            onClick={() => handleCreditPaymentTermCycleClick(EPayCycle.MONTH, EPaymentTerm.STANDARD)}
          >
            End of Month
          </UnitButton>
          <UnitButton
            data-testid={creditStandardInvoiceTestId}
            data-isactive={standardPaymentTermInvoiceDate}
            active={standardPaymentTermInvoiceDate}
            onClick={() => handleCreditPaymentTermCycleClick(EPayCycle.DELIVERY, EPaymentTerm.STANDARD)}
          >
            Invoice Date
          </UnitButton>
        </UnitButtonContainer>

        <DaysInputContainer>
          <span>+</span>
          <InputText
            id="standard-payment-term"
            type="number"
            value={stdPayDelay ?? ''}
            onChange={(e: BaseSyntheticEvent) =>
              updateDealField(EDealField.STANDARD_PAY_DELAY, parseInt(e.target.value, 10))
            }
            placeholder=""
          />
          <span>DAYS</span>
        </DaysInputContainer>
      </InputGroup>
      <br />
      <InputGroup>
        <InputLabel htmlFor="proposed-payment-term">PROPOSED PAYMENT TERM</InputLabel>
        <UnitButtonContainer>
          <UnitButton
            data-testid={creditProposedEndOfMonthTestId}
            data-isactive={proposedPaymentTermEndOfMonth}
            active={proposedPaymentTermEndOfMonth}
            onClick={() => handleCreditPaymentTermCycleClick(EPayCycle.MONTH, EPaymentTerm.PROPOSED)}
          >
            End of Month
          </UnitButton>
          <UnitButton
            data-testid={creditProposedInvoiceTestId}
            data-isactive={proposedPaymentTermInvoiceDate}
            active={proposedPaymentTermInvoiceDate}
            onClick={() => handleCreditPaymentTermCycleClick(EPayCycle.DELIVERY, EPaymentTerm.PROPOSED)}
          >
            Invoice Date
          </UnitButton>
        </UnitButtonContainer>

        <DaysInputContainer>
          <span>+</span>
          <InputText
            id="proposed-payment-term"
            type="number"
            value={payDelay ?? ''}
            onChange={(e: BaseSyntheticEvent) => updateDealField(EDealField.PAY_DELAY, parseInt(e.target.value, 10))}
            placeholder=""
          />
          <span>DAYS</span>
        </DaysInputContainer>
      </InputGroup>
      <br />
      <InputGroup>
        <InputLabel htmlFor="probability-default">PROBABILITY OF DEFAULT</InputLabel>
        <DaysInputContainer>
          <InvisibleSpan>+</InvisibleSpan>
          <InputText
            id="probability-default"
            type="number"
            value={probDefault ?? ''}
            onChange={(e: BaseSyntheticEvent) =>
              updateDealField(EDealField.PROBABILITY_OF_DEFAULT, parseFloat(e.target.value))
            }
            placeholder=""
          />
          <span>%</span>
        </DaysInputContainer>
      </InputGroup>
      <InputGroup>
        <InputLabel htmlFor="additional-credit">OTHER CREDIT ITEMS</InputLabel>
        <InputTextarea
          id="additional-credit"
          value={otherCredit ?? ''}
          onChange={(e: BaseSyntheticEvent) => updateDealField(EDealField.ADDITIONAL_CREDIT_REQUIRMENT, e.target.value)}
        />
      </InputGroup>
    </Container>
  );
};
